Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorPropType = exports.weightPropType = exports.leadingPropType = exports.sizePropType = exports.COLOR = exports.LEADING = exports.SIZE = exports.WEIGHT = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var WEIGHT = exports.WEIGHT = {
  BOLDER: 'bolder',
  DEFAULT: 'default',
  DEPRECATED: 'deprecated', // to be used for medium right now
  LIGHTER: 'lighter'
};

var SIZE = exports.SIZE = {
  TITLE1: 'title1',
  TITLE2: 'title2',
  TITLE3: 'title3',
  LARGE: 'large',
  REGULAR: 'regular',
  SMALL: 'small',
  MINI: 'mini',
  MICRO: 'micro'
};

var LEADING = exports.LEADING = {
  DEFAULT: 'default',
  TALL: 'tall'
};

var COLOR = exports.COLOR = {
  DEFAULT: 'default',
  MUTED: 'muted',
  INHERIT: 'inherit',
  INVERSE: 'inverse'
};

var sizePropType = exports.sizePropType = _propTypes2['default'].oneOf(Object.values(SIZE));
var leadingPropType = exports.leadingPropType = _propTypes2['default'].oneOf(Object.values(LEADING));
var weightPropType = exports.weightPropType = _propTypes2['default'].oneOf(Object.values(WEIGHT));
var colorPropType = exports.colorPropType = _propTypes2['default'].oneOf(Object.values(COLOR));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/constants/typographyConstants.js
// module id = 405
// module chunks = 168707334958949